export default "__VITE_ASSET__DIXR_Vxq__"